export const HEADER_MIN_WIDTH = 950;
export const TABLE_MIN_WIDTH = 991;

export const DURATION_PICKER_OPTIONS = [
  {
    key: "This Week",
    label: "This Week",
  },
  {
    key: "This Month",
    label: "This Month",
  },
  {
    key: "Last Month",
    label: "Last Month",
  },
  {
    key: "Last 12 Months",
    label: "Last 12 Months",
  },
  {
    key: "Previous Year",
    label: "Previous Year",
  },
  {
    key: "This Fiscal Year",
    label: "This Fiscal Year",
  },
  {
    key: "Last Fiscal Year",
    label: "Last Fiscal Year",
  },
];

export const DASHBOARD_CHART_OPTIONS = ["All", "Candidates", "Enterprise"];
export const DASHBOARD_USER_TABLE_OPTIONS = ["Candidates", "Enterprise"];
export const DASHBOARD_ROLES_TABLE_OPTIONS = ["All", "Open", "Draft", "Closed"];

export const ACCEPTED_IMAGE_TYPE = ["image/png", "image/jpeg", "image/jpg"];

export const SORTING_OPTIONS = [
  {
    key: "Most Recent",
    label: "Most Recent",
  },
];

export const SECTORS_OPTION = [
  { label: "Energy", value: "Energy" },
  { label: "Technology", value: "Technology" },
  { label: "Financial Services", value: "Financial Services" },
  { label: "Helath Care", value: "Helath Care" },
  { label: "Telecommunications", value: "Telecommunications" },
  { label: "Basic Materials", value: "Basic Materials" },
  { label: "Industrials", value: "Industrials" },
  { label: "Services", value: "Services" },
  { label: "Food Industry", value: "Food Industry" },
  { label: "Fashion", value: "Fashion" },
  { label: "Animal", value: "Animal" },
];

export const SIZE_PEOPLE_OPTION = [
  { label: "1-10 employees", value: "1-10 employees" },
  { label: "11-50 employees", value: "11-50 employees" },
  { label: "51-200 employees", value: "51-200 employees" },
  { label: "201-500 employees", value: "201-500 employees" },
  { label: "501-1000 employees", value: "501-1000 employees" },
  { label: "1001-5000 employees", value: "1001-5000 employees" },
  { label: "5001-10,000 employees", value: "5001-10,000 employees" },
  { label: "10,001+ employees", value: "10,001+ employees" },
];

export const SIZE_TURNOVER_OPTION = [
  { label: "1000 - 5000", value: "1000 - 5000" },
  { label: "5000 - 10,000", value: "5000 - 10,000" },
  { label: "10,000 - 20,000", value: "10,000 - 20,000" },
  { label: "20,000 - 50,000", value: "20,000 - 50,000" },
  { label: "50,000 - 80,000", value: "50,000 - 80,000" },
  { label: "80,000 - 120,000", value: "80,000 - 120,000" },
  { label: "120,000 - 150,000", value: "120,000 - 150,000" },
  { label: "150,000 - 200,000", value: "150,000 - 200,000" },
  { label: "200,000 - 350,000", value: "200,000 - 350,000" },
  { label: "350,000$ +", value: "350,000$ +" },
];

export const GENDER_OPTIONS = [
  { name: "Female" },
  { name: "Male" },
  { name: "Other" },
  { name: "Unspecified" },
];

export const INDUSTRY_OPTIONS = {
  Energy: [
    { name: "Petroleum products and oil", label: "Petroleum products and oil" },
    { name: "Natural gas", label: "Natural gas" },
    { name: "Gasoline", label: "Gasoline" },
    { name: "Diesel fuel", label: "Diesel fuel" },
    { name: "Heating oil", label: "Heating oil" },
    { name: "Nuclear", label: "Nuclear" },
    { name: "Hydropower", label: "Hydropower" },
    { name: "Biofuels such as ethanol", label: "Biofuels such as ethanol" },
    { name: "Wind power", label: "Wind power" },
    { name: "Solar power", label: "Solar power" },
    { name: "Chemicals", label: "Chemicals" },
  ],

  Technology: [
    { name: "Software and services", label: "Software and services" },
    { name: "Digital Transformation", label: "Digital Transformation" },
    { name: "Computers and Information", label: "Computers and Information" },
    {
      name: "Technology hardware and equipment",
      label: "Technology hardware and equipment",
    },
    { name: "Semiconductors", label: "Semiconductors" },
    {
      name: "Data Processing & Outsourced Services",
      label: "Data Processing & Outsourced Services",
    },
    { name: "Communication Technology", label: "Communication Technology" },
    { name: "Medical Technology", label: "Medical Technology" },
    { name: "Product Technology", label: "Product Technology" },
    { name: "Business Technology", label: "Business Technology" },
    { name: "Educational Technology", label: "Educational Technology" },
    { name: "Information Technology", label: "Information Technology" },
    { name: "Construction Technology", label: "Construction Technology" },
  ],

  "Financial Services": [
    { name: "Real estate", label: "Real estate" },
    { name: "Investment", label: "Investment" },
    { name: "Trade", label: "Trade" },
    { name: "Accounting", label: "Accounting" },
    { name: "Insurance", label: "Insurance" },
    { name: "Credit", label: "Credit" },
    { name: "Commercial Banking", label: "Commercial Banking" },
    { name: "Foreign exchange", label: "Foreign exchange" },
    { name: "Stock market", label: "Stock market" },
    { name: "Audit & Advisory", label: "Audit & Advisory" },
    { name: "Wealth Management", label: "Wealth Management" },
    { name: "Mortgage", label: "Mortgage" },
    { name: "Capital Markets", label: "Capital Markets" },
    { name: "Brokerage", label: "Brokerage" },
    { name: "Consumer Finance", label: "Consumer Finance" },
    { name: "Financial Exchanges & Data", label: "Financial Exchanges & Data" },
  ],

  "Helath Care": [
    { name: "Pharmaceutical", label: "Pharmaceutical" },
    { name: "Hospital", label: "Hospital" },
    { name: "biotechnology", label: "biotechnology" },
    { name: "Medical equipment", label: "Medical equipment" },
    { name: "distribution", label: "distribution" },
    {
      name: "hospital supplies manufacturers",
      label: "hospital supplies manufacturers",
    },
  ],

  Telecommunications: [
    { name: "Entertainment", label: "Entertainment" },
    { name: "Movies", label: "Movies" },
    { name: "Music", label: "Music" },
    { name: "Media", label: "Media" },
  ],

  "Basic Materials": [
    { name: "Garden", label: "Garden" },
    { name: "Home", label: "Home" },
  ],

  Industrials: [
    { name: "Mining", label: "Mining" },
    { name: "Automotive", label: "Automotive" },
    { name: "Steel", label: "Steel" },
    { name: "Auto Parts & Accessories", label: "Auto Parts & Accessories" },
    { name: "Electronics", label: "Electronics" },
    { name: "Tools & Equipment", label: "Tools & Equipment" },
    { name: "Toys", label: "Toys" },
    { name: "fertilizers", label: "fertilizers" },
  ],

  Services: [
    { name: "Academic Services", label: "Academic Services" },
    { name: "Active Life Services", label: "Active Life Services" },
    { name: "Agricultural Services", label: "Agricultural Services" },
    {
      name: "Amusement & Recreation Services",
      label: "Amusement & Recreation Services",
    },
    { name: "Arts & Marketing Services", label: "Arts & Marketing Services" },
    { name: "Arts Services", label: "Arts Services" },
    { name: "Automotive Services", label: "Automotive Services" },
    { name: "Beauty Services", label: "Beauty Services" },
    { name: "Business Services", label: "Business Services" },
    { name: "Children & Baby Services", label: "Children & Baby Services" },
    { name: "Construction Services", label: "Construction Services" },
    { name: "Consulting Services", label: "Consulting Services" },
    { name: "Delivery Services", label: "Delivery Services" },
    {
      name: "Electronic/Technology Services",
      label: "Electronic/Technology Services",
    },
    {
      name: "Engineering & Management Services",
      label: "Engineering & Management Services",
    },
    { name: "Entertainment Services", label: "Entertainment Services" },
    { name: "Concierge Service", label: "Concierge Service" },
    { name: "Event Planning Services", label: "Event Planning Services" },
    { name: "Fashion Services", label: "Fashion Services" },
    { name: "Health & Fitness Services", label: "Health & Fitness Services" },
    { name: "Health & Medical Services", label: "Health & Medical Services" },
    { name: "Food & Nutrition Services", label: "Food & Nutrition Services" },
    { name: "Finance Services", label: "Finance Services" },
    { name: "Home Services", label: "Home Services" },
    { name: "Hospitality Services", label: "Hospitality Services" },
    { name: "Information Services", label: "Information Services" },
    { name: "Legal Services", label: "Legal Services" },
    { name: "Lifestyle Services", label: "Lifestyle Services" },
  ],

  values: [
    { name: "Sale and marketing", label: "Sale and marketing" },
    { name: "Market research", label: "Market research" },
    { name: "Content marketing", label: "Content marketing" },
    { name: "Database marketing", label: "Database marketing" },
    { name: "Social media marketing", label: "Social media marketing" },
    { name: "Influencer marketing.", label: "Influencer marketing." },
    { name: "Event management", label: "Event management" },
  ],

  values: [
    { name: "Books", label: "Books" },
    { name: "Early education", label: "Early education" },
    { name: "Primary education", label: "Primary education" },
    { name: "Secondary", label: "Secondary" },
    { name: "technical", label: "technical" },
    { name: "vocational", label: "vocational" },
    { name: "stationary", label: "stationary" },
  ],

  "Food Industry": [
    { name: "Food & Nutrition", label: "Food & Nutrition" },
    { name: "Hotel", label: "Hotel" },
    { name: "Restaurant", label: "Restaurant" },
    { name: "beverage", label: "beverage" },
    { name: "Dairy", label: "Dairy" },
    { name: "Fruit and Vegetables", label: "Fruit and Vegetables" },
    { name: "sugar and confectionery", label: "sugar and confectionery" },
    { name: "Grain and oilseeds", label: "Grain and oilseeds" },
    { name: "Bakeries", label: "Bakeries" },
    { name: "Agriculture", label: "Agriculture" },
  ],

  Fashion: [
    { name: "Beauty & Cosmetics", label: "Beauty & Cosmetics" },
    { name: "Lifestyle", label: "Lifestyle" },
    { name: "fabrics", label: "fabrics" },
    { name: "leather Industry", label: "leather Industry" },
    { name: "Footwear", label: "Footwear" },
  ],

  Animal: [
    { name: "Pet", label: "Pet" },
    { name: "Live stock", label: "Live stock" },
    { name: "Animal Breeding", label: "Animal Breeding" },
    { name: "Farming", label: "Farming" },
    { name: "Food", label: "Food" },
    { name: "Animal husbandry", label: "Animal husbandry" },
  ],

  values: [{ name: "sport products", label: "sport products" }],

  values: [
    { name: "transport services", label: "transport services" },
    { name: "accommodation", label: "accommodation" },
    {
      name: "food and drink establishments",
      label: "food and drink establishments",
    },
    { name: "travel agencies", label: "travel agencies" },
    {
      name: "transport rental and cultural",
      label: "transport rental and cultural",
    },
    {
      name: "sport and recreation services",
      label: "sport and recreation services",
    },
  ],

  values: [
    { name: "Bricks", label: "Bricks" },
    { name: "Steel", label: "Steel" },
    { name: "Chemical", label: "Chemical" },
  ],
};

export const ROLE_OPTIONS = [
  { name: "hr", label: "hr" },
  { name: "interviewer", label: "interviewer" },
];

export const COUNTRY_BY_CODE = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  CG: "Congo",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  EE: "Estonia",
  FO: "Faroe Islands",
  FI: "Finland",
  FR: "France",
  PF: "French Polynesia",
  GA: "Gabon",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GR: "Greece",
  GL: "Greenland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  HT: "Haiti",
  JO: "Hashemite Kingdom of Jordan",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  XK: "Kosovo",
  KW: "Kuwait",
  LV: "Latvia",
  LB: "Lebanon",
  LY: "Libya",
  LI: "Liechtenstein",
  LU: "Luxembourg",
  MK: "Macedonia",
  MG: "Madagascar",
  MY: "Malaysia",
  MT: "Malta",
  MQ: "Martinique",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  MN: "Mongolia",
  ME: "Montenegro",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar [Burma]",
  NA: "Namibia",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  KR: "Republic of Korea",
  LT: "Republic of Lithuania",
  MD: "Republic of Moldova",
  RO: "Romania",
  RU: "Russia",
  LC: "Saint Lucia",
  SM: "San Marino",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  ZA: "South Africa",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  TW: "Taiwan",
  TZ: "Tanzania",
  TH: "Thailand",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  VI: "U.S. Virgin Islands",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UY: "Uruguay",
  VE: "Venezuela",
  VN: "Vietnam",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};
